"use client"

import { usePathname } from "next/navigation"
import TableOfContents from "@/components/navigation/TableOfContents"

export function TableOfContentsWrapper() {
  const pathname = usePathname()

  return (
    <aside className="w-full lg:w-64 flex-shrink-0 hidden lg:block">
      <h2 className="text-xl font-semibold mb-4">目次</h2>
      <div className="">
        <TableOfContents
          key={pathname}
          contentId="content"
          containerId="content-view"
          targetSelectors="h2, h3, h4"
          ignoreIds={[]}
          tocContainer=".toc-container"
        />
      </div>
    </aside>
  )
}
